<template>
  <div>
    <v-dialog
      v-model="show"
      width="90vw"
      height="90vh"
      max-height="calc(100vh - 30px)"
      max-width="calc(100vw - 30px)"
      scrollable
    >
      <v-card class="height-on-laptop">
        <v-card-title class="py-1">
          Asset Details
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2 pb-0">
          <v-row>
            <v-col cols="12" md="3" lg="3">
              <h5 v-if="asset.Asset_Category_ID">Category</h5>
              <h5 v-else class="red--text">Category*</h5>
              <v-select
                v-if="editMode"
                v-model="asset.Asset_Category_ID"
                :items="listOfCategories"
                item-text="Category_Name"
                item-value="Asset_Category_ID"
                :rules="rules.required"
              >
                <template v-slot:prepend-item>
                  <div class="px-2">
                    <v-text-field
                      label="Search categories"
                      v-model="searchCategories"
                    ></v-text-field>
                  </div>
                </template>
              </v-select>
              <v-text-field
                v-else
                v-model="asset.Category_Name"
                readonly
              ></v-text-field>
              <h5 v-if="asset.Asset_Subcategory_ID">Subcategory</h5>
              <h5 v-else class="red--text">Subcategory*</h5>
              <v-select
                v-if="editMode"
                v-model="asset.Asset_Subcategory_ID"
                :items="listOfSubcategories"
                item-text="Subcategory_Name"
                item-value="Asset_Subcategory_ID"
                :rules="rules.required"
              >
                <template v-slot:prepend-item>
                  <div class="px-2">
                    <v-text-field
                      label="Search categories"
                      v-model="searchSubcategories"
                    ></v-text-field>
                  </div>
                </template>
              </v-select>
              <v-text-field
                v-else
                v-model="asset.Subcategory_Name"
                readonly
              ></v-text-field>
              <h5 v-if="asset.Date_of_Creation" class="color-black">Created Date</h5>
              <h5 v-else class="red--text">Created Date*</h5>
              <DatePicker
                v-if="editMode"
                v-model="asset.Date_of_Creation"
                :rules="rules.required"
              />
              <v-text-field
                v-else
                v-model="asset.Date_of_Creation"
                readonly
              ></v-text-field>
              <h5 :class="editMode ? 'mt-3' : ''">Inventory #</h5>
              <v-text-field
                v-model="asset.Invertory_Number"
                :readonly="!editMode"
              ></v-text-field>
              <h5 v-if="asset.Brand">Brand</h5>
              <h5 v-else class="red--text">Brand*</h5>
              <v-text-field
                v-model="asset.Brand"
                :readonly="!editMode"
                :rules="rules.required"
              ></v-text-field>
              <h5 v-if="asset.Model">Model</h5>
              <h5 v-else class="red--text">Model*</h5>
              <v-text-field
                v-model="asset.Model"
                :readonly="!editMode"
                :rules="rules.required"
              ></v-text-field>
              <h5>Serial №</h5>
              <v-text-field
                v-model="asset.Serial_Number"
                :readonly="!editMode"
              ></v-text-field>
              <h5>Description</h5>
              <v-textarea
                v-model="asset.Description"
                :readonly="!editMode"
                rows="1"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="1" lg="1"></v-col>
            <v-col cols="12" md="3" lg="3">
              <h5 v-if="asset.Status_ID" class="black-color">Status</h5>
              <h5 v-else class="red--text">Status*</h5>
              <v-select
                v-if="editMode"
                v-model="asset.Status_ID"
                :items="listOfAssetStatuses"
                item-text="Status"
                item-value="Status_ID"
                :rules="rules.required"
              >
                <template v-slot:prepend-item>
                  <div class="px-2">
                    <v-text-field
                      label="Search status"
                      v-model="searchStatus"
                    ></v-text-field>
                  </div>
                </template>
              </v-select>
              <v-text-field
                v-else
                v-model="asset.Status"
                readonly
              ></v-text-field>
              <h5>Assigned to Employee</h5>
              <v-select
                v-if="editMode"
                v-model="asset.Employee_ID"
                :items="employeeList"
                item-text="full_name"
                item-value="employee_id"
                clearable
              >
                <template v-slot:prepend-item>
                  <div class="px-2">
                    <v-text-field
                      label="Search employee"
                      v-model="searchEmployee"
                    ></v-text-field>
                  </div>
                </template>
              </v-select>
              <v-text-field
                v-else
                v-model="asset.Full_Name"
                readonly
              ></v-text-field>
              <h5>Current Status Date</h5>
              <DatePicker
                v-if="editMode"
                v-model="asset.Current_Status_Date"
                clearable
              />
              <v-text-field
                v-else
                v-model="asset.Current_Status_Date"
                readonly
              ></v-text-field>
              <v-row v-if="asset.Category_Name === 'Computers' || asset.Category_Name === 'Monitors'">
                <v-col cols="12" md="11" lg="11" class="pb-2 pr-2">
                  <h5 :class="editMode ? 'mt-3' : ''">Lease Agreement Date</h5>
                  <DatePicker
                    v-if="editMode"
                    v-model="asset.Lease_Agreement_Date"
                    clearable
                  />
                  <v-text-field
                    v-else
                    v-model="asset.Lease_Agreement_Date"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" lg="1" class="pl-0">
                  <v-checkbox
                    v-model="asset.Lease_Agreement_Date"
                    class="pt-6"
                    :ripple="false"
                    readonly
                  ></v-checkbox>
                </v-col>
              </v-row>
              <div v-if="asset.Category_Name === 'Computers' || asset.Category_Name === 'Monitors'">
                <h5 :class="editMode ? 'mt-3' : ''">Lease Agreement Document</h5>
                <v-text-field
                  v-if="editMode"
                  v-model="asset.Lease_Agreement_Document_Name"
                  readonly
                  clearable
                  prepend-icon="mdi-paperclip"
                  :error-messages="sameFilesError"
                  @click:clear="() => {
                    clearDocument('Lease_Agreement_Document')
                    asset.isNewLeaseFile = true
                    checkFilesEquality()
                  }"
                  @click.prevent="uploadAgreementFile"
                ></v-text-field>
                <v-file-input
                  v-if="editMode"
                  id="uploaderAgreement"
                  class="d-none"
                  hide-input
                  v-model="asset.Lease_Agreement_Document"
                  @change="onAgreementFileChange"
                  :accept="ALLOWED_FILE_TYPES"
                ></v-file-input>
                <a v-else-if="!editMode && asset.Lease_Agreement_Document_Name" class="my-2 display-inline" @click="openAgreementDocument()">{{ asset.Lease_Agreement_Document_Name }}</a>
                <h5 class="mb-2 mt-2" v-else> No file attached </h5>
              </div>
              <h5>Notes</h5>
              <v-textarea
                v-model="asset.Notes"
                :readonly="!editMode"
                rows="4"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="1" lg="1"></v-col>
            <v-col cols="12" md="3" lg="3">
              <h5>Seller Name</h5>
              <v-text-field
                v-model="asset.Seller_Name"
                :readonly="!editMode"
              ></v-text-field>
              <h5>Seller Contact</h5>
              <v-textarea
                v-model="asset.Seller_Contacts"
                :readonly="!editMode"
                rows="4"
              ></v-textarea>
              <h5>Warranty End Date </h5>
              <DatePicker
                v-if="editMode"
                v-model="asset.Warranty_End_Date"
                clearable
              />
              <v-text-field
                v-else
                v-model="asset.Warranty_End_Date"
                readonly
              ></v-text-field>
              <h5 :class="editMode ? 'mt-3' : ''">Receipt</h5>
              <v-text-field
                v-if="editMode"
                v-model="asset.Receipt_File_Name"
                readonly
                prepend-icon="mdi-paperclip"
                clearable
                :error-messages="sameFilesError"
                @click:clear="() => {
                  clearDocument('Receipt')
                  asset.isNewReceiptFile = true
                  checkFilesEquality()
                }"
                @click.prevent="uploadReceiptFile"
              ></v-text-field>
              <v-file-input
                v-if="editMode"
                id="uploaderReceipt"
                class="d-none"
                hide-input
                v-model="asset.Receipt"
                @change="onReceiptFileChange"
                :accept="ALLOWED_FILE_TYPES"
              ></v-file-input>
              <a v-else-if="!editMode && asset.Receipt_File_Name" class="my-2 display-inline" @click="openReceiptDocument()">{{ asset.Receipt_File_Name }}</a>
              <h5 class="mb-4" v-else> No file attached </h5>
              <h5>Warranty Document</h5>
              <v-text-field
                v-if="editMode"
                v-model="asset.Warranty_Document_Name"
                clearable
                readonly
                prepend-icon="mdi-paperclip"
                :error-messages="sameFilesError"
                @click.prevent="uploadWarrantyFile"
                @click:clear="() => {
                  clearDocument('Warranty_Document')
                  asset.isNewWarrantyFile = true
                  checkFilesEquality()
                }"
              ></v-text-field>
              <v-file-input
                v-if="editMode"
                id="uploaderWarranty"
                class="d-none"
                hide-input
                v-model="asset.Warranty_Document"
                @change="onWarrantyFileChange"
                :accept="ALLOWED_FILE_TYPES"
              ></v-file-input>
              <a v-else-if="!editMode && asset.Warranty_Document_Name" class="mt-2 display-inline" @click="openWarrantyDocument()">{{asset.Warranty_Document_Name}}</a>
              <h5 v-else> No file attached </h5>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-1">
          <v-btn small v-if="!addMode && !editMode" outlined color="primary" @click.prevent="openAssetHistory">History</v-btn>
          <v-btn small v-if="!addMode && !editMode" outlined color="primary" @click.prevent="leaseAgreementDialog = true">Lease Agreement</v-btn>
          <v-spacer></v-spacer>
          <v-btn small v-if="!addMode && !editMode" outlined color="primary" @click.prevent="cloneAsset">Clone</v-btn>
          <v-btn small v-if="!addMode && !editMode" color="red darken-2 white--text" @click.prevent="deleteAssetDialog = true">Delete</v-btn>
          <v-btn small color="primary" :disabled="(editMode && savingDisabled) || isCheckingFiles || areFilesIdentical" @click.prevent="editCurrentAsset">{{ editMode ? 'Save' : 'Edit' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Asset History Dialog -->
    <v-dialog
      v-model="assetHistoryDialog"
      max-width="800"
    >
      <v-card>
        <v-card-title>
          Asset History
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="assetHistoryDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="assetHistoryItems"
            fixed-header
            :headers="assets_headers"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, -1]
            }"
          >
            <template v-slot:[`item.Date_of_Update`]="{ item }">
              {{ item.Date_of_Update | dateFilter }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Lease Agreement Dialog -->
    <AssetsLeaseDialog
      v-if="leaseAgreementDialog"
      v-model="leaseAgreementDialog"
      :asset="asset"
      @generate="handleGenerateLease"
    />

    <!-- Delete dialog -->
    <ConfirmOrDeniedDialog
      v-if="deleteAssetDialog"
      v-model="deleteAssetDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      :title="'Remove current asset'"
      :message="'Are you sure for removing this item?'"
      @onDeleteClick="deleteCurrentAsset"
      @onCancelClick="deleteAssetDialog = false"
    />
    <!-- /Delete dialog -->
  </div>
</template>
<script>
import { ALLOWED_FILE_TYPES } from '@/constants/fileAccept'
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
import { fileToDataUrl } from '@/utils/fileDataUrl'

export default {
  name: 'AssetDetails',
  components: {
    AssetsLeaseDialog: () => import('@/components/assets/AssetsLeaseDialog.vue'),
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    },
    asset: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    },
    assetCategories: {
      required: false,
      default: null
    },
    assetSubcategories: {
      required: false,
      default: null
    },
    notFromAssetsModule: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      leaseAgreementDialog: false,
      edit: false,
      searchCategories: '',
      searchSubcategories: '',
      searchEmployee: '',
      searchStatus: '',
      assetSubcategoriesByCategory: [],
      deleteAsset: false,
      assetHistoryDialog: false,
      assetHistoryItems: [],
      assetStatuses: [],
      deleteAssetDialog: false,
      downloadLink: document.createElement('a'),
      lastReceiptUploaded: null,
      ALLOWED_FILE_TYPES,
      areFilesIdentical: false,
      isCheckingFiles: false,
      fileCheckVersion: 0,
      rules: {
        required: [v => !!v || 'Required']
      },
      assets_headers: [
        {
          text: 'Login',
          value: 'Login',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Employee',
          value: 'Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Status',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Status Date',
          value: 'Date_of_Update',
          divider: true,
          class: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.editMode = false
        this.areFilesIdentical = false
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    employeeList () {
      const r = new RegExp(this.searchEmployee, 'gi')
      return this.$store.getters.getEmployee.filter(item => {
        r.lastIndex = 0
        return r.test(item.full_name)
      })
    },
    listOfCategories () {
      const r = new RegExp(this.searchCategories, 'gi')
      return this.assetCategories.filter(item => {
        if (item.Asset_Category_ID !== 0) {
          r.lastIndex = 0
          return r.test(item.Category_Name)
        }
      })
    },
    listOfSubcategories: {
      get () {
        let res = this.assetSubcategoriesByCategory
        const r = new RegExp(this.searchSubcategories, 'gi')
        if (this.asset.Asset_Category_ID) {
          res = this.assetSubcategories.filter(item => {
            if (item.Asset_Category_ID === this.asset.Asset_Category_ID) {
              r.lastIndex = 0
              return r.test(item.Subcategory_Name)
            }
          })
        } else {
          res = this.assetSubcategories.filter(item => {
            r.lastIndex = 0
            return r.test(item.Subcategory_Name)
          })
        }
        return res
      },
      set (val) {
        this.assetSubcategoriesByCategory = val
      }
    },
    currentSubCategoryName () {
      if (this.asset.Asset_Subcategory_ID) {
        return this.assetSubcategories.filter(item => item.Asset_Subcategory_ID === this.asset.Asset_Subcategory_ID)[0].Subcategory_Name
      } else {
        return ''
      }
    },
    currentCategoryName () {
      if (this.asset.Asset_Category_ID) {
        return this.assetCategories.filter(item => item.Asset_Category_ID === this.asset.Asset_Category_ID)[0].Category_Name
      } else {
        return ''
      }
    },
    listOfAssetStatuses () {
      const r = new RegExp(this.searchStatus, 'gi')
      return this.assetStatuses.filter(item => {
        r.lastIndex = 0
        return r.test(item.Status)
      })
    },
    editMode: {
      get () {
        return this.addMode ? this.addMode : this.edit
      },
      set (val) {
        this.edit = val
      }
    },
    savingDisabled () {
      return !(this.asset.Asset_Category_ID && this.asset.Asset_Subcategory_ID && this.asset.Status_ID && this.asset.Date_of_Creation && this.asset.Brand && this.asset.Model)
    },
    sameFilesError () {
      return this.areFilesIdentical
        ? ['Uploaded files must be unique and cannot be identical to each other']
        : []
    }
  },
  mounted () {
    if (!this.employeeList.length) {
      this.getEmployeeList()
    }
    this.getAssetStatuses()
  },
  methods: {
    getEmployeeList () {
      this.axios.get('/api/employeelist', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setEmployeeList', { employeeList: response.data })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    handleGenerateLease (payload) {
      this.axios.post('/api/assets/generate-lease-agreement', payload, {
        headers: { Authorization: 'Bearer ' + this.user.token },
        responseType: 'arraybuffer'
      })
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url

          const employee = this.employeeList.find(e => e.employee_id === payload.employeeId)
          const employeeName = employee ? employee.full_name.replace(/ /g, '_') : 'Employee'
          const assetName = `${this.asset.Brand}_${this.asset.Model}`.replace(/ /g, '_')

          link.setAttribute('download', `Lease_Agreement_${assetName}_${employeeName}.docx`)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)

          this.$store.dispatch('setSuccess', { successMsg: 'Document generated!' })
        })
        .catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg: 'Failed to generate document: ' + errorMsg })
        })
    },
    openAssetHistory () {
      this.assetHistoryItems = []
      this.axios.get(`/api/asset/history/${this.asset.Asset_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        for (let i = 0; i < response.data.length; i++) {
          this.assetHistoryItems.push(response.data[i])
        }
        this.assetHistoryDialog = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    editCurrentAsset () {
      if (this.isCheckingFiles || this.areFilesIdentical) return

      if (this.editMode && !this.asset.Asset_ID) {
        if (this.asset.Asset_Category_ID && this.asset.Asset_Subcategory_ID) {
          this.axios.post('/api/assets', this.asset, {
            headers: {
              Authorization: 'Bearer ' + this.user.token
            }
          }).then(res => {
            this.asset.Asset_ID = res.data.Asset_ID
            if (this.asset.Employee_ID || this.asset.Status_ID) {
              this.addAssetChangingToHistory()
              if (this.asset.Employee_ID) {
                this.sendEmailForAccept(this.asset)
              }
            }
            this.editMode = false
            this.show = false
            this.searchEmployee = ''
            this.areFilesIdentical = false
            this.$store.dispatch('setSuccess', { successMsg: 'Asset added' })
          }).catch(error => {
            const errorMsg = getApiErrorMessage(error)
            this.$store.dispatch('setError', { errorMsg })
          })
        } else {
          this.$store.dispatch('setError', { errorMsg: 'Category and subcategory are required' })
        }
      } else if (this.editMode && this.asset.Asset_ID) {
        this.axios.put(`/api/assets/${this.asset.Asset_ID}`, this.asset, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          if ((this.asset.Employee_ID && this.asset.Old_Owner !== this.asset.Employee_ID) || (this.asset.Status_ID && this.asset.Old_Status !== this.asset.Status_ID)) {
            this.addAssetChangingToHistory()
            if (this.asset.Employee_ID && this.asset.Old_Owner !== this.asset.Employee_ID) {
              this.sendEmailForAccept(this.asset)
            }
          }
          this.editMode = false
          this.show = false
          this.searchEmployee = ''
          this.areFilesIdentical = false
          this.$store.dispatch('setSuccess', { successMsg: 'Asset updated' })
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else {
        if (this.asset.Status_ID) {
          this.asset.Old_Status = this.asset.Status_ID
        }
        if (this.asset.Employee_ID) {
          this.asset.Old_Owner = this.asset.Employee_ID
        }
        this.editMode = true
      }
    },
    deleteCurrentAsset () {
      this.axios.delete(`/api/assets/${this.asset.Asset_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.deleteAssetDialog = false
        this.show = false
        this.editMode = false
        this.$store.dispatch('setSuccess', { successMsg: 'Asset deleted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sendEmailForAccept (asset) {
      const employeeIDs = asset.Employee_ID
      const body = {
        employeeIDs: employeeIDs,
        Asset: asset
      }
      this.axios.post('/api/emails/sendemailonassetaccepted', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    addAssetChangingToHistory () {
      const body = {
        Asset_ID: this.asset.Asset_ID,
        Employee_ID: this.asset.Employee_ID,
        Status_ID: this.asset.Status_ID,
        Status_Date: this.asset.Current_Status_Date
      }
      this.axios.post('/api/asset/history', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Added to history' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateAssetHistory (employeeID, statusID) {
      let status = this.asset.Status_ID
      if (statusID && statusID !== this.asset.Status_ID) {
        status = this.asset.Old_Status
      }
      const body = {
        Employee_ID: employeeID,
        Status_ID: status,
        Status_Date: this.asset.Current_Status_Date
      }
      this.axios.put(`/api/asset/history/${this.asset.Asset_ID}`, body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'History updated' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getAssetStatuses () {
      this.axios.get('/api/assets_status', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.assetStatuses = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    cloneAsset () {
      this.show = false
      setTimeout(() => {
        this.show = true
        this.editMode = true
        this.asset.Asset_ID = null
      }, 1000)
    },
    uploadReceiptFile () {
      document.getElementById('uploaderReceipt').click()
    },
    uploadWarrantyFile () {
      document.getElementById('uploaderWarranty').click()
    },
    uploadAgreementFile () {
      document.getElementById('uploaderAgreement').click()
    },
    async calculateBufferSHA256 (bufferData) {
      if (!bufferData) return null

      let uint8Array

      if (bufferData?.data && Array.isArray(bufferData.data)) {
        uint8Array = new Uint8Array(bufferData.data)
      } else if (Array.isArray(bufferData)) {
        uint8Array = new Uint8Array(bufferData)
      } else if (bufferData instanceof ArrayBuffer) {
        uint8Array = new Uint8Array(bufferData)
      } else if (bufferData instanceof Uint8Array) {
        uint8Array = bufferData
      } else {
        return null
      }

      const hashBuffer = await crypto.subtle.digest('SHA-256', uint8Array.buffer)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    },
    async calculateFileSHA256 (file) {
      if (!file || !(file instanceof File)) return null

      const buffer = await file.arrayBuffer()
      const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
      const hashArray = Array.from(new Uint8Array(hashBuffer))

      return hashArray
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('')
    },
    async checkFilesEquality () {
      const checkVersion = ++this.fileCheckVersion
      this.areFilesIdentical = false

      const docConfigs = [
        { key: 'Lease_Agreement_Document', nameKey: 'Lease_Agreement_Document_Name' },
        { key: 'Receipt', nameKey: 'Receipt_File_Name' },
        { key: 'Warranty_Document', nameKey: 'Warranty_Document_Name' }
      ]

      const activeDocs = docConfigs.filter(doc => {
        const val = this.asset?.[doc.key]
        const name = this.asset?.[doc.nameKey]

        if (val instanceof File) return true

        if (name && typeof name === 'string' && name.trim() !== '') {
          const rawData = val?.data || val
          if (Array.isArray(rawData) && rawData.length > 0) return true
          if (rawData?.data && Array.isArray(rawData.data) && rawData.data.length > 0) return true
          if (rawData instanceof ArrayBuffer && rawData.byteLength > 0) return true
        }

        return false
      })

      if (activeDocs.length < 2) {
        this.isCheckingFiles = false
        this.areFilesIdentical = false
        return
      }

      this.isCheckingFiles = true

      try {
        const hashPromises = activeDocs.map(async (doc) => {
          const val = this.asset?.[doc.key]

          if (val instanceof File) {
            return await this.calculateFileSHA256(val)
          }

          const rawData = val?.data || val
          if (rawData) {
            return await this.calculateBufferSHA256(rawData)
          }

          if (this.asset?.Asset_ID) {
            try {
              const res = await this.axios.get(`/api/assets_getfiles/${this.asset.Asset_ID}`, {
                headers: { Authorization: 'Bearer ' + this.user.token }
              })
              const serverDoc = res?.data?.[0]?.[doc.key]
              if (serverDoc) {
                this.asset[doc.key] = serverDoc
                return await this.calculateBufferSHA256(serverDoc.data || serverDoc)
              }
            } catch (e) {
              console.warn(`Error fetching ${doc.key}:`, e)
            }
          }

          return null
        })

        const hashes = await Promise.all(hashPromises)

        if (checkVersion !== this.fileCheckVersion) return

        const validHashes = hashes.filter(h => typeof h === 'string' && h.trim().length > 0)

        if (validHashes.length < 2) {
          this.areFilesIdentical = false
          return
        }

        const hasDuplicates = validHashes.some((hash, index) => validHashes.indexOf(hash) !== index)
        this.areFilesIdentical = hasDuplicates
      } catch (error) {
        if (checkVersion !== this.fileCheckVersion) return

        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', {
          errorMsg: 'File SHA-256 calculation error: ' + errorMsg
        })
      } finally {
        if (checkVersion === this.fileCheckVersion) {
          this.isCheckingFiles = false
        }
      }
    },
    async onReceiptFileChange (e) {
      if (!e) {
        this.clearDocument('Receipt')
        this.checkFilesEquality()
        return
      }
      try {
        const res = await fileToDataUrl(e)
        if (!this.asset.Receipt) {
          this.asset.Receipt = {}
        }
        this.asset.Receipt.data = res.data
        this.asset.Receipt.base64String = res.base64String
        this.asset.Receipt_File_Name = e.name
        this.asset.Receipt_File_Type = e.type
        this.asset.isNewReceiptFile = true
      } catch (error) {
        this.clearDocument('Receipt')
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
      this.checkFilesEquality()
    },

    async onWarrantyFileChange (e) {
      if (!e) {
        this.clearDocument('Warranty_Document')
        this.checkFilesEquality()
        return
      }
      try {
        const res = await fileToDataUrl(e)
        if (!this.asset.Warranty_Document) {
          this.asset.Warranty_Document = {}
        }
        this.asset.Warranty_Document.data = res.data
        this.asset.Warranty_Document.base64String = res.base64String
        this.asset.Warranty_Document_Name = e.name
        this.asset.Warranty_Document_Type = e.type
        this.asset.isNewWarrantyFile = true
      } catch (error) {
        this.clearDocument('Warranty_Document')
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
      this.checkFilesEquality()
    },

    async onAgreementFileChange (e) {
      if (!e) {
        this.clearDocument('Lease_Agreement_Document')
        this.checkFilesEquality()
        return
      }
      try {
        const res = await fileToDataUrl(e)
        if (!this.asset.Lease_Agreement_Document) {
          this.asset.Lease_Agreement_Document = {}
        }
        this.asset.Lease_Agreement_Document.data = res.data
        this.asset.Lease_Agreement_Document.base64String = res.base64String
        this.asset.Lease_Agreement_Document_Name = e.name
        this.asset.Lease_Agreement_Document_Type = e.type
        this.asset.isNewLeaseFile = true
      } catch (error) {
        this.clearDocument('Lease_Agreement_Document')
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
      this.checkFilesEquality()
    },
    openReceiptDocument () {
      const linkSource = this.linkToReceipt()
      this.downloadLink.href = linkSource
      this.downloadLink.download = this.asset.Receipt_File_Name
      this.downloadLink.click()
    },
    openWarrantyDocument () {
      const linkSource = this.linkToWarrantyDocument()
      this.downloadLink.href = linkSource
      this.downloadLink.download = this.asset.Warranty_Document_Name
      this.downloadLink.click()
    },
    openAgreementDocument () {
      const linkSource = this.linkToAgreement()
      this.downloadLink.href = linkSource
      this.downloadLink.download = this.asset.Lease_Agreement_Document_Name
      this.downloadLink.click()
    },
    linkToReceipt () {
      let res = ''
      if (this.asset.Receipt_File_Type && this.asset.Receipt && this.asset.Receipt.data) {
        let binary = ''
        const bytes = new Uint8Array(this.asset.Receipt.data)
        const len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        res = `data:${this.asset.Receipt_File_Type};base64, ${window.btoa(binary)}`
      }
      return res
    },
    linkToWarrantyDocument () {
      let res = ''
      if (this.asset.Warranty_Document_Type && this.asset.Warranty_Document && this.asset.Warranty_Document.data) {
        let binary = ''
        const bytes = new Uint8Array(this.asset.Warranty_Document.data)
        const len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        res = `data:${this.asset.Warranty_Document_Type};base64, ${window.btoa(binary)}`
      }
      return res
    },
    linkToAgreement () {
      let res = ''
      if (this.asset.Lease_Agreement_Document_Type && this.asset.Lease_Agreement_Document && this.asset.Lease_Agreement_Document.data) {
        let binary = ''
        const bytes = new Uint8Array(this.asset.Lease_Agreement_Document.data)
        const len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        res = `data:${this.asset.Lease_Agreement_Document_Type};base64, ${window.btoa(binary)}`
      }
      return res
    },
    getAssetFiles () {
      if (!this.asset?.Asset_ID) return

      this.axios.get(`/api/assets_getfiles/${this.asset.Asset_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        const fileData = response.data[0]
        if (!fileData) return

        this.asset.Lease_Agreement_Document = fileData.Lease_Agreement_Document
        this.asset.Lease_Agreement_Document_Name = fileData.Lease_Agreement_Document_Name
        this.asset.Lease_Agreement_Document_Type = fileData.Lease_Agreement_Document_Type

        this.asset.Receipt = fileData.Receipt
        this.asset.Receipt_File_Name = fileData.Receipt_File_Name
        this.asset.Receipt_File_Type = fileData.Receipt_File_Type

        this.asset.Warranty_Document = fileData.Warranty_Document
        this.asset.Warranty_Document_Name = fileData.Warranty_Document_Name
        this.asset.Warranty_Document_Type = fileData.Warranty_Document_Type

        this.checkFilesEquality()
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    clearDocument (type) {
      this.asset[type] = null
      this.asset[`${type}_Name`] = ''
      this.asset[`${type}_Type`] = ''
      if (type === 'Receipt') this.asset.Receipt_File_Name = ''
      if (type === 'Warranty_Document') this.asset.Warranty_Document_Name = ''
      if (type === 'Lease_Agreement_Document') this.asset.Lease_Agreement_Document_Name = ''
    }
  },
  filters: {
    dateFilter (val) {
      return val ? formatLocalDate(val) : ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .black-color {
    color: #fff;
  }
  .display-inline {
    display: inline-block;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .v-input__slot {
    margin-bottom: 0;
  }
  @media (max-width: 1366px) {
    .height-on-laptop {
      height: 90vh;
    }
  }
  @media (min-width: 1367px) {
    .height-on-laptop {
      height: 80vh;
    }
  }
  @media (max-width: 1366px) {
    .v-text-field::v-deep input {
    padding: 0px;
    }
  }
</style>
